/**
 * Calculate the new cursor position after formatting
 * Preserves cursor position by counting digits before the cursor
 * @param oldValue - The value before formatting
 * @param newValue - The value after formatting
 * @param oldCursor - The cursor position before formatting
 * @returns The new cursor position that maintains relative position
 */
export const calculateCursorPosition = (
  oldValue: string,
  newValue: string,
  oldCursor: number,
): number => {
  // If cursor was at the end, keep it at the end
  if (oldCursor >= oldValue.length) {
    return newValue.length;
  }

  // Count digits and decimal separator before cursor in old value
  const beforeCursor = oldValue.slice(0, oldCursor);
  const digitsBeforeCursor = beforeCursor.replace(/[^\d,]/g, "").length;

  // If cursor is at position 0 (no digits before it), return 0
  if (digitsBeforeCursor === 0) {
    return 0;
  }

  // Find position in new value that has the same number of digits
  let digitCount = 0;
  let newPosition = 0;

  for (let i = 0; i < newValue.length; i++) {
    if (/[\d,]/.test(newValue[i])) {
      digitCount++;
      if (digitCount === digitsBeforeCursor) {
        newPosition = i + 1;
        break;
      }
    }
  }

  // If we haven't found the position, return the end
  if (newPosition === 0) {
    newPosition = newValue.length;
  }

  return newPosition;
};
